module.exports = __webpack_public_path__ + "static/media/Golfview-Pointe-at-Copper-Creek.7e4cd949.pdf";